import { Component, Injector, Inject, OnInit } from '@angular/core';
import { ContactBaseComponent } from './../common-theme/index';
import { OpenModalService } from '../common-theme/base-components/shared/modals/open-modal.service';
import { AgencyService } from '../common-theme/api/agency.service';
import { DOCUMENT } from '@angular/platform-browser';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})

export class ContactComponent extends ContactBaseComponent implements OnInit {
  constructor(
    injector: Injector,
    agencyService: AgencyService,
    @Inject('WINDOW') window: any,
    @Inject(DOCUMENT) private document: any,
    private openModalService: OpenModalService
  ) {
    super(injector, agencyService, window);
  }

  openMessageModal(): void {
    this.openModalService.showContactFormModal();

    if (this.document)
      this.document.body.classList.add('no-scroll');
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.setTitle('Contacteaza echipa proiectului rezidential Dream Residence');
    this.setMetaDescription(
      `Contacteaza-ne. Dream Residence s-a nascut din dorinta de a face ceva diferit si din a crea un acasa perfect pentru fiecare rezident. Intra in legatura cu noi.`
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/contact/contact.component.ts